import { ReactComponent as Check } from "../../../assets/images/icon/check.svg";
import { Modal } from "antd";
import "./index.css";
import { TextBtn } from "../../";
import { isIOS } from "react-device-detect";
import { useEffect, useState } from "react";
import { useMyContext } from "../../../entities/context";

interface IProps {
  isOpen: boolean;
  setIsOpen: Function;
  header?: React.ReactNode;
  dataList: IBottomSheet[];
  value?: string | number;
  setValue?: (curr: any) => void;
  isShowLabel?: boolean;
  title?: string | React.ReactNode;
  onCustomContentNode?: (
    data: IBottomSheet,
    value: string | number
  ) => React.ReactNode;
  customContentHeight?: number;
  styles?: {
    modal?: React.CSSProperties;
    modalContent?: React.CSSProperties;
    data?: React.CSSProperties;
    textBtnStyle?: React.CSSProperties;
    clearLabelStyle?: React.CSSProperties,
    textBtnStyles?: {
      container?: React.CSSProperties;
      icon?: React.CSSProperties;
      children?: React.CSSProperties;
    };
  };
  addtionalHeight?: string;
  onClick?: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    data: IBottomSheet
  ) => void;
  clearLabel?: string | React.ReactNode;
  classNames?: {
    textBtnClassNames: { container?: string; icon?: string; children?: string };
  };
  decreaseHeight?: number
}

const BottomSheet = ({
  onCustomContentNode,
  customContentHeight,
  header,
  title,
  isOpen,
  setIsOpen,
  dataList,
  setValue,
  value,
  isShowLabel,
  styles,
  onClick,
  addtionalHeight = "0px",
  clearLabel,
  classNames,
  decreaseHeight = 0
}: IProps) => {
  const { topHeight } = useMyContext();
  const contentHeight =
    dataList.length * (customContentHeight ? customContentHeight : 56) +
    40 +
    (title ? 39 : 0) +
    (header ? 52 : 0) +
    (isIOS ? 34 : 0);
  const minWidth = window.innerWidth <= 480 ? "100vw" : "480px";
  const marginInline =
    window.innerWidth <= 480 ? "0" : (window.innerWidth - 480) / 2;
  const [targetHeight, setTargetHeight] = useState<number>(
    contentHeight + Number(addtionalHeight.replace("px", ""))
  );

  const onContentClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    data: IBottomSheet
  ) => {
    if (onClick !== undefined) {
      onClick(event, data);
    } else {
      setValue?.(data.value);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const checkHeight = window.innerHeight - Number(topHeight) - decreaseHeight;
    if (
      contentHeight + Number(addtionalHeight.replace("px", "")) >=
      checkHeight
    ) {
      setTargetHeight(checkHeight);
    } else {
      setTargetHeight(
        contentHeight + Number(addtionalHeight.replace("px", ""))
      );
    }
  }, [contentHeight, addtionalHeight]);

  return (
    <>
      {isShowLabel && (
        <TextBtn
          classNames={classNames?.textBtnClassNames}
          style={dataList.find((data) => data.value === value)?.label ? styles?.textBtnStyle : styles?.clearLabelStyle}
          styles={styles?.textBtnStyles}
          rightIcon="arrowDown"
          onClick={() => setIsOpen(true)}
        >
          {dataList.find((data) => data.value === value)?.label ?? clearLabel}
        </TextBtn>
      )}
      <Modal
        transitionName="custom-modal"
        style={{
          top: `calc(100vh - ${targetHeight + "px"})`,
          padding: 0,
          margin: 0,
          ...styles?.modal
        }}
        styles={{
          content: {
            minWidth: minWidth,
            height: targetHeight + "px",
            overflow: "scroll",
            borderRadius: "5% 5% 0 0",
            padding: `0 0 ${isIOS ? "34px" : 0} 0 `,
            marginInline: marginInline + "px",
            ...styles?.modalContent,
          },
          body: { padding: "var(--space20)", }
        }}
        open={isOpen}
        closeIcon={null}
        footer={null}
        onCancel={() => setIsOpen(false)}
      >
        {header !== undefined && header}
        {title && (
          <div
            className="title/t1"
            style={{ color: "#111111", marginBottom: "var(--space20)" }}
          >
            {title}
          </div>
        )}
        {dataList.map((data) => (
          <div
            style={{
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "var(--space12) 0px var(--space12) var(--space12)",
              cursor: "pointer",
              ...styles?.data,
            }}
            key={data.id}
            onClick={(e) => onContentClick(e, data)}
          >
            {onCustomContentNode !== undefined ? (
              onCustomContentNode(data, value ?? "")
            ) : (
              <>
                <div
                  className={data.value === value ? "sub-title/st3" : "body/b3"}
                >
                  {data.label}
                </div>
                {data.value === value && (
                  <Check
                    width={16}
                    height={16}
                    stroke={"#000000"}
                    style={{ padding: "var(--space8)" }}
                  />
                )}
              </>
            )}
          </div>
        ))}
      </Modal>
    </>
  );
};

export { BottomSheet };
